import { Control } from 'react-hook-form';
import {
    IJobQuestionsForm,
    JobQuestionObjectFields,
    QuestionType,
} from '../../../../../../common';
import {
    FormInputText,
    Icon,
    IconButton,
    Radio,
    Checkbox,
    useTheme,
} from '../../../../../../base';
import {
    StyledOptionItemWrapper,
    StyledOptionItemContent,
    StyledOptionInputWrapper,
} from '../../JobQuestions.styles';
import { useTranslation } from 'react-i18next';

interface OptionItemProps {
    fieldNamePrefix: `questions.${number}`;
    control: Control<IJobQuestionsForm>;
    optionIndex: number;
    isCorrectAnswer: boolean;
    isDealbreaker: boolean;
    hasBeenSubmitted: boolean;
    optionValueError: boolean;
    questionType?: string;
    onDealbreakerChange: () => void;
    onRemove: () => void;
}

export const OptionItem = ({
    fieldNamePrefix,
    control,
    optionIndex,
    isCorrectAnswer,
    isDealbreaker,
    hasBeenSubmitted,
    optionValueError,
    questionType,
    onDealbreakerChange,
    onRemove,
}: OptionItemProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const isMultipleSelection = questionType === QuestionType.MULTIPLE_SELECT;

    const selectionControlSx = {
        padding: 0,
        '& .MuiSvgIcon-root': {
            fontSize: 18,
        },
        '&.Mui-disabled': {
            color: theme.palette.grey[400],
        },
    };

    return (
        <StyledOptionItemWrapper>
            <StyledOptionItemContent>
                {isMultipleSelection ? (
                    <Checkbox
                        checked={isCorrectAnswer}
                        onChange={onDealbreakerChange}
                        disabled={!isDealbreaker}
                        size="small"
                        sx={selectionControlSx}
                    />
                ) : (
                    <Radio
                        checked={isCorrectAnswer}
                        onChange={onDealbreakerChange}
                        disabled={!isDealbreaker}
                        size="small"
                        sx={selectionControlSx}
                    />
                )}
                <StyledOptionInputWrapper>
                    <FormInputText
                        name={`${fieldNamePrefix}.${JobQuestionObjectFields.OPTIONS}.${optionIndex}.label`}
                        control={control}
                        placeholder={t('saveJob.optionValuePlaceholder')}
                        size="small"
                        hideCharacterCount={true}
                        removeBottomPadding={
                            !hasBeenSubmitted || !optionValueError
                        }
                        sx={{
                            paddingBottom:
                                hasBeenSubmitted && optionValueError
                                    ? theme.spacing(2)
                                    : 0,
                        }}
                    />
                </StyledOptionInputWrapper>
                <IconButton
                    onClick={onRemove}
                    size="small"
                    sx={{
                        padding: 0,
                        minWidth: 'auto',
                        width: '14px',
                        height: '14px',
                    }}
                >
                    <Icon name="CloseIcon" sx={{ fontSize: 8 }} />
                </IconButton>
            </StyledOptionItemContent>
        </StyledOptionItemWrapper>
    );
};
